import { call, put, takeLatest } from 'redux-saga/effects';
import { Types, Creators } from './settings-duck.js';
import * as Api from './settings-api.js';
import { Creators as GlobalCreators } from '../globals/globals-duck.js';
import toastApiError from 'utils/api-error.js';

export function* getSettings() {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const response = yield call(Api.getSettings);
    yield put(Creators.settingsFetched(response.data));

    const whatsapp = response.data.find((s) => s.key === 'whatsapp_link');
    const whatsappMessage = response.data.find((s) => s.key === 'whatsapp_message');
    const whatsappProductMessage = response.data.find((s) => s.key === 'whatsapp_product_message');
    if (whatsapp) {
      yield put(Creators.settingsSetWhatsappLink(whatsapp.value));
    }

    if (whatsappMessage) {
      yield put(Creators.settingsSetWhatsappMessage(whatsappMessage.value));
    }

    if (whatsappProductMessage) {
      yield put(Creators.settingsSetWhatsappProductMessage(whatsappProductMessage.value));
    }
  } catch (error) {
    toastApiError(error);
  } finally {
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* updateSetting({ data }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    yield call(Api.saveSetting, data);
  } catch (error) {
    toastApiError(error);
  } finally {
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export default [
  //Management
  takeLatest(Types.SETTINGS_FETCH_ASYNC, getSettings),
  takeLatest(Types.SETTINGS_SAVE_ASYNC, updateSetting),
];
